import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./GlassPill.module.css";

const GlassPill = React.forwardRef(({ className, children, ...rest }, ref) => (
  <button
    ref={ref}
    type="button"
    className={clsx(css.glassPill, className)}
    {...rest}
  >
    {children}
  </button>
));

GlassPill.displayName = "GlassPill";

GlassPill.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default GlassPill;
